var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBack = function SvgBack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Back",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icons-\\uD83D\\uDD04",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-69.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Library_Items-/-Title-/-Descriptions-Copy-7",
    transform: "translate(33.000000, 165.000000)",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 16,
    letterSpacing: -0.0266666671
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.086957)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-dolor-si"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Back",
    transform: "translate(69.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.14644661,1.64644661 C4.32001296,1.47288026 4.58943736,1.45359511 4.7843055,1.58859116 L4.85355339,1.64644661 L11.2071068,8 L4.85355339,14.3535534 C4.65829124,14.5488155 4.34170876,14.5488155 4.14644661,14.3535534 C3.97288026,14.179987 3.95359511,13.9105626 4.08859116,13.7156945 L4.14644661,13.6464466 L9.793,8 L4.14644661,2.35355339 C3.97288026,2.17998704 3.95359511,1.91056264 4.08859116,1.7156945 L4.14644661,1.64644661 Z",
    id: "Icons/16/Back",
    transform: "translate(7.603553, 8.000000) rotate(-180.000000) translate(-7.603553, -8.000000) "
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "back.d99a896dcefdad32df633d70ee76c990.svg";